<template>
    <button
        class="lock_element_btn tooltipElement"
        :class="getActiveElement.isLocked ? 'isLocked' : ''"
        @click="lockElement"
    >
        <inline-svg
            :src="lock_icon"
            :fill="getActiveElement.isLocked ? '#ffffff' : '#707070'"
        />
        <Tooltip :tooltipText="`${ $t('editorSceneElementOptionsLock') }`" />
    </button>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Tooltip from '@/components/Global/Tooltip.vue';
    import lock_icon from '@/assets/icons/lock.svg';

    export default {
        data() {
            return {
                lock_icon
            }
        },
        methods: {
            lockElement() {
                this.$store.dispatch('LOCK_PAGE_ELEMENT', !this.getActiveElement.isLocked)
            }
        },
        computed: {
            ...mapGetters([
                'getActiveElement'
            ])
        },
        components: {
            Tooltip
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/setup/_variables.scss';

    .lock_element_btn {
        background-color: unset;
        border: none;
        border-right: 1px solid #D4D4D4;
        cursor: pointer;
        display: flex;
        align-content: center;
        justify-content: center;
    }
    .lock_element_btn:disabled {
        cursor: not-allowed;
    }
    .isLocked {
        background-color: #707070;
        border-color: #707070;
    }
</style>